import * as React from 'react';
import classNames from 'clsx';

import { CompactHeadingSectionProps } from './CompactHeadingSection.interfaces';
import { useStyles } from './CompactHeadingSection.styles';

function CompactHeadingSection({
  className,
  title,
  id,
}: CompactHeadingSectionProps) {
  const classes = useStyles();

  return (
    <h3 className={classNames(classes.root, className)} {...(id && { id })}>
      {title}
    </h3>
  );
}

export default CompactHeadingSection;
